import * as React from "react";
import {
  FormatClearRounded,
  FormatStrikethroughRounded,
  FormatUnderlinedRounded,
} from "@mui/icons-material";
import { TXGUISection } from "../../interfaces/gui/fields.interfaces";
import { MAIN_COLOR, SECONDARY_COLOR } from "../../constants/common/utils";

export const X_PRODUCT_DETAILS_GUI_FIELDS: TXGUISection = {
  Général: [
    {
      type: "toggle_option",
      name: "previewMode",
      label: "Mode",
      options: [
        { value: "grid", label: "Grille" },
        { value: "list", label: "Liste" },
      ],
      defaultValue: "grid",
    },
    {
      type: "toggle_option",
      name: "containerMode",
      label: "type de Container",
      options: [
        { value: "NONE", label: "Aucun" },
        { value: "CENTER", label: "Centrer" },
        { value: "FILL", label: "Large" },
      ],
      defaultValue: "CENTER",
    },
    {
      type: "toggle_option",
      name: "previewPosition",
      label: "Positionement de la previsualisation",
      options: [
        { value: "left", label: "Gauche" },
        { value: "right", label: "Droite" },
        { value: "top", label: "Haut" },
      ],
      defaultValue: "left",
    },
    {
      type: "toggle_option",
      name: "detailsGroupMode",
      label: "Mode des details",
      options: [
        { value: "column", label: "Colonne" },
        { value: "row", label: "Ligne" },
      ],
      defaultValue: "column",
    },
    {
      type: "sizing",
      name: "detailsGap",
      label: "Espacement des details",
      units: ["px", "em"],
      defaultValue: "10px",
    },
    {
      type: "color",
      name: "textColor",
      label: "Couleur des textes",
      defaultValue: "#000000",
    },
    {
      type: "sizing",
      name: "textFontSize",
      label: "Taille de la police",
      units: ["px", "em", "rem", "pt"],
      defaultValue: "16px",
    },
    {
      type: "sides",
      name: "padding",
      label: "Espace Interne (Padding)",
      units: ["px", "em", "%", "auto"],
    },
    {
      type: "sides",
      name: "margin",
      label: "Espace Externe (Margin)",
      units: ["px", "em", "%", "auto"],
    },
  ],
  "Titre des Sections": [
    {
      type: "color",
      name: "titleColor",
      label: "Couleur des textes",
      defaultValue: "#000000",
    },
    {
      type: "sizing",
      name: "titleFontSize",
      label: "Taille de la police",
      units: ["px", "em", "rem", "pt"],
      defaultValue: "10px",
    },
    {
      type: "select_option",
      name: "titleFontWeight",
      label: "Epaisseur de la police",
      options: [
        { value: 100, label: "Mince" },
        { value: 200, label: "Tres Léger" },
        { value: 300, label: "Léger" },
        { value: 400, label: "Normal" },
        { value: 500, label: "Moyen" },
        { value: 600, label: "Semi-gras" },
        { value: 700, label: "Gras" },
        { value: 800, label: "Extra Gras" },
        { value: 900, label: "Lourd" },
      ],
      defaultValue: 600,
    },
    {
      type: "sizing",
      name: "titleLetterSpacing",
      label: "Espacement des lettres",
      placeholder: "10",
      units: ["px", "em"],
      defaultValue: "1px",
    },
  ],
  "Nom de l'Article": [
    {
      type: "color",
      name: "nameColor",
      label: "Couleur des textes",
      defaultValue: "#000000",
    },
    {
      type: "sizing",
      name: "nameFontSize",
      label: "Taille de la police",
      units: ["px", "em", "rem", "pt"],
      defaultValue: "28px",
    },
    // {
    //   type: "font",
    //   name: "nameFontFamily",
    //   label: "Police",
    //   defaultValue: "inherit",
    // },
    {
      type: "toggle_option",
      name: "nameFontStyle",
      label: "Style de la police",
      options: [{ value: "normal" }, { value: "italic" }],
      defaultValue: "normal",
    },
    {
      type: "select_option",
      name: "nameFontWeight",
      label: "Epaisseur de la police",
      options: [
        { value: 100, label: "Mince" },
        { value: 200, label: "Tres Léger" },
        { value: 300, label: "Léger" },
        { value: 400, label: "Normal" },
        { value: 500, label: "Moyen" },
        { value: 600, label: "Semi-gras" },
        { value: 700, label: "Gras" },
        { value: 800, label: "Extra Gras" },
        { value: 900, label: "Lourd" },
      ],
      defaultValue: 600,
    },
  ],
  "Prix de l'Article": [
    {
      type: "color",
      name: "priceColor",
      label: "Couleur des textes",
      defaultValue: "#000000",
    },
    {
      type: "sizing",
      name: "priceFontSize",
      label: "Taille de la police",
      units: ["px", "em", "rem", "pt"],
      defaultValue: "28px",
    },
    // {
    //   type: "font",
    //   name: "priceFontFamily",
    //   label: "Police",
    //   defaultValue: "inherit",
    // },
    {
      type: "toggle_option",
      name: "priceFontStyle",
      label: "Style de la police",
      options: [{ value: "normal" }, { value: "italic" }],
      defaultValue: "normal",
    },
    {
      type: "select_option",
      name: "priceFontWeight",
      label: "Epaisseur de la police",
      options: [
        { value: 100, label: "Mince" },
        { value: 200, label: "Tres Léger" },
        { value: 300, label: "Léger" },
        { value: 400, label: "Normal" },
        { value: 500, label: "Moyen" },
        { value: 600, label: "Semi-gras" },
        { value: 700, label: "Gras" },
        { value: 800, label: "Extra Gras" },
        { value: 900, label: "Lourd" },
      ],
      defaultValue: 300,
    },
  ],
  Reduction: [
    {
      type: "color",
      name: "discountColor",
      label: "Couleur du texte",
      defaultValue: "#777777",
    },
    {
      type: "sizing",
      name: "discountFontSize",
      label: "Taille de la police",
      units: ["px", "em", "rem", "pt"],
      defaultValue: "24px",
    },
    // {
    //   type: "font",
    //   name: "discountFontFamily",
    //   label: "Police",
    //   defaultValue: "inherit",
    // },
    {
      type: "toggle_option",
      name: "discountFontStyle",
      label: "Style de la police",
      options: [{ value: "normal" }, { value: "italic" }],
      defaultValue: "normal",
    },
    {
      type: "select_option",
      name: "discountFontWeight",
      label: "Epaisseur de la police",
      options: [
        { value: 100, label: "Mince" },
        { value: 200, label: "Tres Léger" },
        { value: 300, label: "Léger" },
        { value: 400, label: "Normal" },
        { value: 500, label: "Moyen" },
        { value: 600, label: "Semi-gras" },
        { value: 700, label: "Gras" },
        { value: 800, label: "Extra Gras" },
        { value: 900, label: "Lourd" },
      ],
      defaultValue: 600,
    },
    {
      type: "toggle_option",
      name: "discountTextDecoration",
      label: "Decoration",
      options: [
        { value: "none", label: "Aucune", icon: <FormatClearRounded /> },
        {
          value: "underline",
          label: "Souligner",
          icon: <FormatUnderlinedRounded />,
        },
        {
          value: "line-through",
          label: "Barrer",
          icon: <FormatStrikethroughRounded />,
        },
      ],
      defaultValue: "line-through",
    },
  ],
  "Notes de l'Article": [
    {
      type: "toggle_option",
      name: "showReviews",
      label: "Afficher",
      options: [
        {
          value: false,
          label: "Non",
        },
        { value: true, label: "Oui" },
      ],
      defaultValue: true,
    },
    {
      type: "color",
      name: "starIconColor",
      label: "Couleur de l'Icone",
      defaultValue: SECONDARY_COLOR,
    },
    {
      type: "sizing",
      name: "starIconSize",
      label: "Taille de l'Icone",
      units: ["px", "em", "rem", "pt"],
      defaultValue: "20px",
    },
    {
      type: "toggle_option",
      name: "starCountMode",
      label: "Mode",
      options: [
        { value: "none", label: "Aucun" },
        { value: "number", label: "Nombre" },
        { value: "full", label: "Texte" },
      ],
      defaultValue: "full",
    },
  ],
  "Choix de Couleurs": [
    {
      type: "border",
      name: "colorPickerBorder",
      label: "Contoure Actif",
      units: ["px", "em"],
      defaultValue: { width: "2px", color: "#000000" },
    },
    {
      type: "sizing",
      name: "colorPickerSize",
      label: "Taille",
      units: ["px", "em"],
      defaultValue: "40px",
    },
  ],
  "Tags & Badges": [
    // {
    //   type: "font",
    //   name: "toggleFontFamily",
    //   label: "Police",
    //   defaultValue: "inherit",
    // },
    {
      type: "color",
      name: "toggleBgColor",
      label: "Couleur de l'Arriere Plan",
      defaultValue: "#FFFFFF00",
    },
    {
      type: "border",
      name: "toggleBorder",
      label: "Contour",
      units: ["px", "em"],
      defaultValue: { width: "2px", color: "#EEEEEE" },
    },
    {
      type: "sizing",
      name: "toggleFontSize",
      label: "Taille de la police",
      units: ["px", "em", "rem", "pt"],
      defaultValue: "16px",
    },
    {
      type: "sizing",
      name: "toggleHeight",
      label: "Hauteur",
      units: ["px", "em"],
      defaultValue: "50px",
    },
    {
      type: "sizing",
      name: "toggleWidth",
      label: "Largeur",
      units: ["px", "em"],
      defaultValue: "80px",
    },
    {
      type: "radius",
      name: "toggleRadius",
      label: "Arrondis",
      units: ["px", "em", "%"],
      defaultValue: {
        TopLeft: "5px",
        TopRight: "5px",
        BottomLeft: "5px",
        BottomRight: "5px",
      },
    },
    {
      type: "sizing",
      name: "toggleSpacing",
      label: "Espacement",
      units: ["px", "em"],
      defaultValue: "10px",
    },

    {
      type: "color",
      name: "toggleTextColor",
      label: "Couleur du Texte",
      defaultValue: "#000000",
    },
    {
      type: "border",
      name: "toggleActiveBorder",
      label: "Contour (Actif)",
      units: ["px", "em"],
      defaultValue: { width: "2px", color: MAIN_COLOR },
    },
    {
      type: "color",
      name: "toggleActiveBgColor",
      label: "Couleur de l'Arriere Plan (Actif)",
    },
    {
      type: "color",
      name: "toggleActiveTextColor",
      label: "Couleur du Texte (Actif)",
      defaultValue: MAIN_COLOR,
    },
  ],
  Selectioneur: [
    // {
    //   type: "font",
    //   name: "selectFontFamily",
    //   label: "Police",
    //   defaultValue: "inherit",
    // },
    {
      type: "sizing",
      name: "selectFontSize",
      label: "Taille de la police",
      units: ["px", "em", "rem", "pt"],
      defaultValue: "16px",
    },
    {
      type: "sizing",
      name: "selectHeight",
      label: "Hauteur",
      units: ["px", "em"],
      defaultValue: "50px",
    },
    {
      type: "sizing",
      name: "selectWidth",
      label: "Largeur",
      units: ["px", "em", "%"],
      defaultValue: "50%",
    },
    {
      type: "border",
      name: "selectBorder",
      label: "Contour",
      units: ["px", "em"],
      defaultValue: { width: "1px", color: "#EEEEEE" },
    },
    {
      type: "color",
      name: "selectTextColor",
      label: "Couleur du Texte",
      defaultValue: "#000000",
    },
  ],
  "Choix de la Quantite": [
    {
      type: "toggle_option",
      name: "inputMode",
      label: "type de Container",
      options: [
        { value: "minus_plus", label: "Avec Button" },
        { value: "arrow", label: "Normal" },
      ],
      defaultValue: "minus_plus",
    },
    // {
    //   type: "font",
    //   name: "inputFontFamily",
    //   label: "Police",
    //   defaultValue: "inherit",
    // },
    {
      type: "sizing",
      name: "inputFontSize",
      label: "Taille de la police",
      units: ["px", "em", "rem", "pt"],
      defaultValue: "14px",
    },
    {
      type: "color",
      name: "inputContainerBgColor",
      label: "Couleur de l'Arriere Plan",
    },
    {
      type: "radius",
      name: "inputContainerRadius",
      label: "Arrondis",
      units: ["px", "em", "%"],
      defaultValue: {
        TopLeft: "5px",
        TopRight: "5px",
        BottomLeft: "5px",
        BottomRight: "5px",
      },
    },
    {
      type: "border",
      name: "inputContainerBorder",
      label: "Contour",
      units: ["px", "em"],
      defaultValue: { width: "2px", color: "#EEEEEE" },
    },
    {
      type: "sizing",
      name: "inputHeight",
      label: "Hauteur",
      units: ["px", "em"],
      defaultValue: "50px",
    },
    {
      type: "sizing",
      name: "inputWidth",
      label: "Largeur",
      units: ["px", "em", "%"],
      defaultValue: "250px",
    },
    {
      type: "border",
      name: "inputBorder",
      label: "Contour du Champs",
      units: ["px", "em"],
      defaultValue: { width: "2px", color: "#FFFFFF" },
    },
    {
      type: "color",
      name: "inputTextColor",
      label: "Couleur du Texte",
      defaultValue: "#000000",
    },

    // BTN
    {
      type: "sizing",
      name: "inputBtnSize",
      label: "Taille des Boutons",
      units: ["px", "em", "rem", "pt"],
      defaultValue: "40px",
    },
    {
      type: "radius",
      name: "inputBtnRadius",
      label: "Arrondis",
      units: ["px", "em", "%"],
      defaultValue: {
        TopLeft: "50%",
        TopRight: "50%",
        BottomLeft: "50%",
        BottomRight: "50%",
      },
    },
    {
      type: "color",
      name: "inputBtnBgColor",
      label: "Arriere Plan des Boutons",
      defaultValue: "#FFFFFF",
    },
    {
      type: "color",
      name: "inputBtnTextColor",
      label: "Couleur du Texte des Boutons",
      defaultValue: "#000000",
    },
    {
      type: "color",
      name: "inputBtnHoverBgColor",
      label: "Arriere Plan des Boutons (Survole)",
      defaultValue: "#000000",
    },
    {
      type: "color",
      name: "inputBtnHoverTextColor",
      label: "Couleur du Texte des Boutons (Survole)",
      defaultValue: "#FFFFFF",
    },
  ],
  "Ajouter au Panier": [
    // {
    //   type: "font",
    //   name: "btnFontFamily",
    //   label: "Police",
    //   defaultValue: "inherit",
    // },
    {
      type: "sizing",
      name: "btnFontSize",
      label: "Taille de la police",
      units: ["px", "em", "rem", "pt"],
      defaultValue: "14px",
    },
    {
      type: "color",
      name: "btnBgColor",
      label: "Couleur de l'Arriere Plan",
      defaultValue: MAIN_COLOR,
    },
    {
      type: "color",
      name: "btnTextColor",
      label: "Couleur du Texte",
      defaultValue: "#FFFFFF",
    },
    {
      type: "sizing",
      name: "btnHeight",
      label: "Hauteur",
      units: ["px", "em"],
      defaultValue: "50px",
    },
    {
      type: "sizing",
      name: "btnWidth",
      label: "Largeur",
      units: ["px", "em", "%"],
      defaultValue: "250px",
    },
    {
      type: "radius",
      name: "btnRadius",
      label: "Arrondis",
      units: ["px", "em", "%"],
      defaultValue: {
        TopLeft: "5px",
        TopRight: "5px",
        BottomLeft: "5px",
        BottomRight: "5px",
      },
    },
    {
      type: "border",
      name: "btnBorder",
      label: "Contour",
      units: ["px", "em"],
    },
    {
      type: "color",
      name: "btnHoverBgColor",
      label: "Couleur de l'Arriere Plan (Survole)",
    },
    {
      type: "color",
      name: "btnHoverTextColor",
      label: "Couleur du Texte (Survole)",
      defaultValue: "#FFFFFF",
    },
  ],
};
